// Надёжное определение Telegram user_id и подписанной initData.
//
// Проблема, которую это решает: на части клиентов Telegram отдаёт
// initDataUnsafe.user.id / initData НЕ мгновенно (webview прогревается),
// из-за чего старый код сваливался на фейковый '1' и показывал пустой
// баланс ($0.00). Здесь мы:
//   1) берём id из структурного initDataUnsafe.user.id,
//   2) если пусто — парсим id из ПОДПИСАННОЙ строки initData (user=<json>),
//   3) '1' отдаём только реально ВНЕ Telegram (см. вызывающий код).

function _tg() {
  try { return window?.Telegram?.WebApp || null; } catch (e) { return null; }
}

// Реальный Telegram id пользователя или null (не '1').
export function getTgUserId() {
  const tg = _tg();
  if (!tg) return null;
  try {
    const direct = tg.initDataUnsafe?.user?.id;
    if (direct) return String(direct);
  } catch (e) {}
  // Фолбэк: id из подписанной строки initData (user=<urlencoded json>)
  try {
    const raw = tg.initData || '';
    if (raw) {
      const u = new URLSearchParams(raw).get('user');
      if (u) {
        const parsed = JSON.parse(u);
        if (parsed && parsed.id) return String(parsed.id);
      }
    }
  } catch (e) {}
  return null;
}

// Подписанная строка initData (для авторизации на бэке через HMAC) или null.
export function getTgInitData() {
  const tg = _tg();
  try {
    const raw = tg?.initData;
    return raw && raw.length ? raw : null;
  } catch (e) { return null; }
}

// true — мы реально внутри Telegram-webview (есть подпись или id).
export function isInsideTelegram() {
  return !!(getTgInitData() || getTgUserId());
}
